function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M45.7627 15.4654V11.1496C45.7627 10.2692 45.7676 9.92307 45.5814 9.46733C45.2263 8.66294 44.3594 8.12502 43.4888 8.12502C42.2076 8.12502 41.1976 9.16226 41.1976 10.5382V15.4642H39.5378V10.8134C39.5378 9.61551 39.8264 8.79618 40.4565 7.98805C41.1791 7.07906 42.321 6.53491 43.4839 6.53491C44.8255 6.53491 46.1721 7.29821 46.8947 8.47865C47.2264 9.02404 47.4225 9.88322 47.4225 10.8981V15.4667H45.7627V15.4654Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M54.1813 15.4989C51.7311 15.4989 49.6594 13.4817 49.6594 11.0935C49.6594 8.5184 51.6546 6.50244 54.2011 6.50244C56.671 6.50244 58.681 8.53459 58.681 11.0312C58.6823 13.4942 56.6636 15.4989 54.1813 15.4989ZM54.2011 8.1299C52.5709 8.1299 51.3402 9.38505 51.3402 11.0499C51.3402 12.5566 52.6411 13.8291 54.1813 13.8291C55.7474 13.8291 57.0212 12.5553 57.0212 10.9901C57.0212 9.41369 55.756 8.1299 54.2011 8.1299Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.047 6.49487H35.3872V15.5051H37.047V6.49487Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.9119 15.5051L23.6489 6.49487H25.6404L28.4088 12.8752L31.2734 6.49487H33.2378L28.9625 15.5051H27.9119Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M70.3401 11.0337C70.3401 14.5526 69.4289 17.8511 67.832 20.7213C67.5249 21.2729 67.9281 21.9552 68.5546 21.9552C68.8555 21.9552 69.1341 21.7921 69.2772 21.5257C71.011 18.2969 71.9999 14.8514 71.9999 11.0349C71.9999 7.16738 71.0073 3.49158 69.2673 0.42717C69.1193 0.165681 68.8456 0.0461426 68.5472 0.0461426H68.5361C67.9096 0.0461426 67.5052 0.682434 67.8122 1.23405C69.4215 4.12414 70.3401 7.46 70.3401 11.0337Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M1.65979 11.0797C1.65979 14.5986 2.57108 17.8971 4.16798 20.7673C4.47503 21.3189 4.0718 22.0012 3.44537 22.0012C3.14448 22.0012 2.86579 21.8381 2.72275 21.5717C0.98897 18.3416 0 14.8962 0 11.0797C0 7.21214 0.99267 3.49151 2.73262 0.425855C2.88183 0.164365 3.15435 0 3.45276 0H3.46386C4.09029 0 4.49476 0.681118 4.18771 1.23274C2.57848 4.12407 1.65979 7.50475 1.65979 11.0797Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M22.3234 11.4384C22.3321 11.2293 22.337 11.1745 22.337 11.0624C22.337 8.56455 20.327 6.51123 17.857 6.51123C15.3106 6.51123 13.3154 8.51723 13.3154 11.091C13.3154 13.4793 15.3859 15.4903 17.8373 15.4903C19.6241 15.4903 21.1717 14.4481 21.898 12.9464L20.2986 12.386C19.8079 13.2377 18.8892 13.8143 17.8373 13.8143C16.4365 13.8143 15.2379 12.6936 15.0319 11.4372H22.3234V11.4384ZM17.8558 8.11752C18.9681 8.11752 19.9299 8.71397 20.3887 9.76242H15.2662C15.7139 8.71397 16.6794 8.11752 17.8558 8.11752Z"
});

function SvgLogoEvino(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 22,
    viewBox: "0 0 72 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEvino);
export default __webpack_public_path__ + "static/media/logo_evino.0481c7f4.svg";
export { ForwardRef as ReactComponent };